import React from "react";
import { isHexColor, isSystemColorValue } from "../helpers";
import { useTheme } from "../../components/ThemeProvider";
import { EDionColorNames, EDionColorGroups } from "../../tokens";
const DEFAULT_COLOR = EDionColorGroups.elevation0;
const COLOR_NAMES = new Set(Object.values(EDionColorNames));
const ParentColorContext = React.createContext(DEFAULT_COLOR);
const useParentBg = () => {
  return React.useContext(ParentColorContext) ?? DEFAULT_COLOR;
};
const isColorName = (color) => color && COLOR_NAMES.has(color);
const useCurrentColor = (bg, color, fill) => {
  const { palette } = useTheme();
  const parentBg = React.useContext(ParentColorContext) ?? DEFAULT_COLOR;
  let [rawBg, rawColor] = color?.split(".") || [];
  let safeBg = bg;
  if (isColorName(rawBg)) {
    rawColor = rawBg;
    rawBg = void 0;
  }
  if (isSystemColorValue(safeBg) || isHexColor(safeBg)) {
    safeBg = void 0;
    console.error(`useCurrentColor: incompatible color prop provided ${bg} for bg, please provide DionColorGroups`);
  }
  if (isHexColor(rawBg)) {
    rawColor = void 0;
    rawBg = void 0;
    console.error(`useCurrentColor: incompatible color prop provided ${color} for color, please provide DionColorType`);
  }
  if (isHexColor(rawColor)) {
    rawColor = void 0;
    console.error(`useCurrentColor: incompatible color prop provided ${rawColor} for color, please provide DionColorType`);
  }
  const ctx = safeBg ?? rawBg ?? parentBg;
  const defaultBg = fill ? palette[ctx].main : "transparent";
  const hBg = safeBg || rawBg ? palette[safeBg ?? rawBg].main : defaultBg;
  const hColor = safeBg || rawBg || rawColor ? palette[safeBg ?? rawBg ?? parentBg][rawColor ?? "contrast"] : "currentColor";
  return {
    ctx,
    color: hColor,
    bg: hBg,
    passCtx: !!(safeBg || rawBg),
    Provider: ParentColorContext.Provider
  };
};
export {
  ParentColorContext,
  isColorName,
  useCurrentColor,
  useParentBg
};
